// root '../../../';

// dependencies
import { Child } from 'pym.js';
import * as d3 from 'd3';
import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// styles
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';
import data from './data/data.json';

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

const subheds = {
  Cabinet: 'Cabinet members',
  'Cabinet-level positions': 'People Trump has announced are invited to join his Cabinet',
  'Other key roles': 'Other key roles',
};

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  draw();
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

window.onresize = pymChild.sendHeight;

function draw() {
  const container = d3.select('#graphic');
  container.html('');

  const groups = Array.from(new Set(data.map(d => d.category))).sort();
  console.log(groups);

  // Add confirmed number message
  container.append('p')
    .attr('class', 'confirmed-count')
    .text(`Cabinet members confirmed: ${meta.confirmed_num}/22`);

  // Create a container for the progress bar
  const progressContainer = container.append('div')
    .attr('class', 'confirmed-progress-container');

  // Create the progress bar
  const progressBar = progressContainer.append('div')
    .attr('class', 'progress-bar');
  // Create the progress fill element
  progressBar.append('div')
    .attr('class', 'progress-fill')
    .style('width', `${meta.confirmed_num_pct}%`);

  const group = container.selectAll('.category')
    .data(groups)
    .enter()
    .append('div')
    .attr('class', 'category');

  group.append('h3')
    .text(d => subheds[d]);

  const people = group.append('div')
    .attr('class', 'people');

  const person = people.selectAll('.person')
    .data(d => data.filter(e => e.category == d))
    .enter()
    .append('div')
    .attr('class', d => `person ${d.confirmed == 'yes' ? 'confirmed' : d.confirmed == 'no' ? 'unconfirmed' : 'not-required'}`)
    .append('a')
    .attr('href', d => d.profile_url);

  person.append('img')
    .attr('class', d => `portrait ${d.name == 'Unannounced' || d.name.startsWith('Withdraw') ? 'unannounced' : ''}`)
    .attr('src', d => `./img/${d.img}`);

  const name = person.append('div')
    .attr('class', 'name')
    .append('p')
    .html(d => d.name);

  person.append('div')
    .attr('class', 'role')
    .append('p')
    .text(d => d.title);

  window.setTimeout(pymChild.sendHeight, 100);
}
